'use client';

import React from 'react';
import { useTradingData } from '@/hooks/useTradingData';
import { RefreshCw, Wifi, WifiOff } from 'lucide-react';

export const ConnectionStatus: React.FC = () => {
  const { connectionStatus, lastUpdated, refreshData, derivAccount } = useTradingData();

  const isConnected = connectionStatus === 'connected';
  const isConnecting = connectionStatus === 'connecting';

  const formatTime = (date: Date | null) => {
    if (!date) return 'N/A';
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  return (
    <div className="flex items-center space-x-3 px-3 py-1.5 rounded-lg bg-slate-900/80 border border-slate-800/80 text-xs backdrop-blur-md">
      <div className="flex items-center space-x-2">
        {isConnected ? (
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
          </span>
        ) : isConnecting ? (
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-spin inline-block h-2.5 w-2.5 rounded-full border-2 border-amber-500 border-t-transparent"></span>
          </span>
        ) : (
          <span className="relative flex h-2.5 w-2.5">
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
          </span>
        )}

        <div className="flex items-center space-x-1.5 font-medium">
          {isConnected ? (
            <Wifi className="w-3.5 h-3.5 text-emerald-400" />
          ) : (
            <WifiOff className="w-3.5 h-3.5 text-red-400" />
          )}
          <span className={isConnected ? 'text-emerald-400' : 'text-red-400'}>
            {isConnected
              ? `Deriv Connected ${derivAccount ? `(${derivAccount.loginid})` : ''}`
              : isConnecting
              ? 'Connecting Deriv...'
              : 'Deriv Disconnected'}
          </span>
        </div>
      </div>

      <div className="h-3 w-[1px] bg-slate-800 hidden sm:block"></div>

      <div className="text-slate-400 hidden sm:flex items-center space-x-1.5">
        <span>Updated:</span>
        <span className="font-mono text-slate-300">{formatTime(lastUpdated)}</span>
      </div>

      <button
        onClick={() => refreshData()}
        className="p-1 hover:bg-slate-800 rounded transition-colors text-slate-400 hover:text-slate-200"
        title="Sync Connection"
      >
        <RefreshCw className="w-3 h-3" />
      </button>
    </div>
  );
};

export default ConnectionStatus;
